import DeviceUsageModal from './device-usage-net-modal.connect'

export default DeviceUsageModal
